// extracted by mini-css-extract-plugin
module.exports = {"highlightCard":"HighlightCard_highlightCard__38rEC"};